import { format } from 'date-fns';
import { ExaminationItemsParsed, ExaminationItem } from './types';

const examinationItemParser = (
  data: ExaminationItem
): ExaminationItemsParsed => ({
  type: 'examination',
  id: data!.id || '',
  competence_id: data!.competence_id || '',
  lesson_id: data!.lesson_id || '',
  name: data!.name || '',
  title: data!.name || '',
  instruction: data!.instruction || '',
  description: data!.instruction || '',
  count_attempt: data!.count_attempt || '',
  run_before: data!.run_before ? format(data!.run_before, 'YYYY-MM-DD') : '',
  date: data!.run_before ? format(data!.run_before, 'YYYY-MM-DD') : '',
  new_page: data!.new_page || '',
  edit_answers: data!.edit_answers || false,
  random_order: data!.random_order || false,
  status: data!.status || '',
  is_deleted: data!.is_deleted || false,
  assessment_type: data!.assessment_type || '',
  time_for_question: data!.time_for_question || false,
  lesson_name: data!.lesson_name || '',
  count_questions: data!.count_questions || '',
  test_runtime: data!.test_runtime || '',
  questions: data!.questions || [],
  result_params: data!.result_params || {},
  results: data!.results || {},
  events_name: data!.events_name || '',
  group_id: data!.group_id || '',
  group_name: data!.group_name || '',
  module_name: data!.module_name || '',
  schedule_run_before: data!.schedule_run_before
    ? format(data!.schedule_run_before, 'YYYY-MM-DD')
    : '',
  theme_name: data!.theme_name || '',
  schedule_id: data!.schedule_id,
});

export default examinationItemParser;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/examinationItemParser.ts